// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InstructionCategorySchema = z.enum(['AUTHENTICATION_SETUP','ENVIRONMENT_CONFIG','TESTING_CREDENTIALS','API_ENDPOINTS','BUSINESS_WORKFLOWS','DATA_SETUP','TECHNICAL_REQUIREMENTS','SCOPE_LIMITATIONS','SPECIAL_INSTRUCTIONS','CSRF_SETUP','WEBPAGE_MAPPING','AI_BROWSER','DEEP_SECURITY_SCAN'] as const);

export type InstructionCategoryType = `${z.infer<typeof InstructionCategorySchema>}`

export default InstructionCategorySchema;
